export default "__VITE_ASSET__DlaUb3b7__"